/* eslint-disable react/no-multi-comp */

import React from "react";
import Actions from "okpay/actions/Actions";
import C from "okpay/util/Constants";
import _str from "shared/util/_str";

import "./nav.scss";

const NavButton = (props) => {
	if (props.hidden) {
		return null;
	}

	const _onClick = (e) => {
		if (props.isSubmitting) {
			return;
		}

		Actions.changeBillingType(props.id);
	};

	return (
		<button
			className={`okpay-nav-item okpay-nav-item-${props.id}`}
			key={props.id}
			onClick={this._onClick}
		>
			{props.children}
		</button>
	);
};

const Nav = (props) => {
	const { skipPaypal } = props;
	let navItems = [
		{
			id: C.billingTypes.card,
			name: _str("Credit/Debit"),
		},
		{
			id: C.billingTypes.paypal,
			name: _str("PayPal"),
			hidden: skipPaypal,
		},
	];

	navItems = navItems.map((item) => {
		return (
			<NavButton
				{...item}
				key={item.id}
				product={props.product}
				isSubmitting={props.isSubmitting}
			>
				{item.name}
			</NavButton>
		);
	});

	return <div className="okpay-nav">{navItems}</div>;
};

export default Nav;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/Nav.jsx